import { copy as sharedUiCopy } from '@shared/copy';
import { SkeletonTree } from '@shared/ui/Skeleton';

/**
 * The pending state of `/taxonomy/categories`.
 *
 * The tree at its real depths — a root, one child inset by a step, a second root
 * — because depth is the one thing this surface exists to show. It draws no third
 * level: a childless root renders as a childless root here, never padded with a
 * fabricated child, and a placeholder that promised a grandchild would break that
 * rule before the data even arrives.
 */
export function CategoriesSkeleton() {
  return (
    <>
      <p role="status" className="sr-only">
        {sharedUiCopy.state.loading}
      </p>

      <SkeletonTree rows={3} />
    </>
  );
}
